import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["categories", "hsSoftwareCategories", "buttonText", "buttonUse", "onClickOption"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Big } from 'foundations-components/transitional/components/Big';
import { MultiLevelDropdown } from 'foundations-components/transitional/components/Dropdown';

// @ts-expect-error Could not find a declaration file for module
import { useSearchParamSingleSelect } from 'academy-common-lib/hooks/searchParamHooks';
import { FILTER_TYPES_OTHER } from 'academy-common-lib/constants/TopFilterConstants';
import UsageTracker from '../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const CatalogDropdownMenu = _ref => {
  let {
      categories,
      hsSoftwareCategories,
      buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.tracks"
      }),
      buttonUse = 'tertiary-light',
      onClickOption
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const filterTypeCategories = FILTER_TYPES_OTHER.CATEGORIES;
  const filterTypeTools = FILTER_TYPES_OTHER.TOOLS;
  const [__, setCatalogFilter] = useSearchParamSingleSelect();
  const trackFilterSelect = (selectedOption, filterType) => {
    UsageTracker.track('catalogDropdownInteraction', {
      action: 'catalog-option-selected',
      value: selectedOption,
      key: filterType
    });
    UsageTracker.track('filterInteraction', {
      action: 'filter-selected',
      value: selectedOption,
      key: filterType,
      isDropdown: true
    });
  };
  const handleOnClickOption = (selectedOption, filterType) => {
    setCatalogFilter(filterType, selectedOption);
    trackFilterSelect(selectedOption, filterType);
    onClickOption === null || onClickOption === void 0 || onClickOption(selectedOption, filterType);
  };
  const renderOptionsHeading = title => {
    const optionsHeading = {
      label: /*#__PURE__*/_jsx(Big, {
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.categories.${title}`
          })
        })
      })
    };
    return optionsHeading;
  };
  const renderSubCategories = (category, filterType) => category.map(cat => ({
    value: `{{ ${cat} }}`,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.topFilters.${filterType}.${cat}`
    }),
    onClick: () => {
      handleOnClickOption(cat, filterType);
    }
  })).toArray();
  const renderCategoryOptions = (items, filterType) => items.map((category, index) => Object.assign({
    'data-test-id': `option-${index}`,
    value: `{{ ${index} }}`,
    label: /*#__PURE__*/_jsx(View, {
      paddingInlineStart: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: typeof category === 'object' ? `learningCenter.topFilters.${filterType}group.${index}` : `learningCenter.topFilters.${filterType}.${index}`
      })
    }),
    onClick: typeof category === 'object' ? null : () => {
      handleOnClickOption(index, filterType);
    }
  }, typeof category === 'object' && {
    options: renderSubCategories(category, filterType)
  })).toArray();
  const getGroupOptionsWithHeading = (filterType, groupHeading) => {
    const options = renderCategoryOptions(filterType === filterTypeCategories ? categories : hsSoftwareCategories, filterType);
    options.splice(0, 0, renderOptionsHeading(groupHeading));
    return options;
  };
  const renderCategories = () => {
    return getGroupOptionsWithHeading(filterTypeCategories, 'categories');
  };
  const renderSoftwareCategories = () => {
    return getGroupOptionsWithHeading(filterTypeTools, 'hubspotSoftware');
  };
  const renderOptions = () => {
    return [...renderCategories(), ...renderSoftwareCategories()];
  };
  const onDropdownOpen = () => {
    UsageTracker.track('catalogDropdownInteraction', {
      action: 'catalog-dropdown-opened'
    });
  };
  return /*#__PURE__*/_jsx(MultiLevelDropdown, Object.assign({
    buttonText: buttonText,
    buttonUse: buttonUse,
    "data-test-id": "catalog-dropdown-filter",
    minMenuWidth: 240,
    onOpenComplete: onDropdownOpen,
    options: [renderOptions()],
    paddingBlock: buttonUse === 'tertiary-light' ? '500' : '0',
    paddingInline: buttonUse === 'link-on-dark' ? '0' : undefined
  }, rest));
};
export default CatalogDropdownMenu;